import React from 'react';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

import Button from '@xcritical/button';

import { LeadGridFormatterTemplateWithInject } from '@crm-lead/lead-short-info';

import { NotificationText } from '../notification-grid/styles';

export const getDealsIdComponent = (deals: string[]): JSX.Element => {
  // TODO: url can be too long
  const url = `/open-deals-report?filters=${btoa(
    JSON.stringify({ dealIds: deals })
  )}`;

  return (
    <Button
      appearance="notificationLink"
      textPosition="left"
      outline={false}
      shouldFitContent
      href={url}
      target="_blank">
      <NotificationText>{deals.join(', ')}</NotificationText>
    </Button>
  );
};

export const checkShowRow = (field: any) =>
  !isUndefined(field) && !isNull(field);

export const LeadInfo = ({ leadId }) => (
  <LeadGridFormatterTemplateWithInject leadId={leadId} justifyContent="start" />
);
